export default __webpack_public_path__ + "static/media/om-1.db3cf19d.jpg";